import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { UserService } from 'app/services/user.service';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private userService: UserService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.userService.currentUserValue;
        if (currentUser) {
            if (new Date(this.userService.access_token_expires_at) > new Date()) {
                // authorised so return true
                return true;
            } else {
                // try to refresh
                return this.userService.refreshToken().pipe(tap((isLoggedIn) => {
                    if (!isLoggedIn) {
                        this.router.navigate(['/login'], { queryParams: { returnUrl: (state.url == '/logout')? '/home': state.url }});
                    }
                }));
            }
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: (state.url == '/logout')? '/home': state.url }});
        return false;
    }
}